'use client';

import React from 'react';
import Layout from '$modules/onboarding/layout';
const OnboardingLayout = ({
  children
}: {
  children: React.ReactNode;
}) => {
  return <>
      <Layout data-sentry-element="Layout" data-sentry-source-file="layout.tsx">{children}</Layout>
    </>;
};
export default OnboardingLayout;